<template>
  <div>
    <Loader v-if="loading" />
    <div class="container">
      <div v-if="reject_remark!=''" style="padding-top:3%; margin-bottom:-20px">
        <p><b>नकाराचे कारण : </b>{{ reject_remark }}</p>
      </div>
      <div v-if="survey_submitted == 1"></div>
      <div class="card" style="padding: 10px; border:none">
        <div v-if="show_survey==false">
          <h1>{{show_msg}}</h1>
        </div>
      </div>
      <div v-if="show_survey==true" style="margin-top: 10px">
        <SurveyComponent v-if="survey" :model="survey" />
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import 'survey-core/survey-core.css';
import { Model } from "survey-core";
import { SurveyComponent } from "survey-vue3-ui";
import data from "@/data";
import axios from "axios";
import apis from "@/apis";
import lambda from "@/apis/lambda";
import Swal from "sweetalert2";
import { themeJson } from "./theme";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

export default {
  name: "SURVEY",
  components: { Loader,SurveyComponent },
  data() {
    return {
      loading: false,
      survey: null,
      surveytemplate: {},
      sgb_board_id: "",
      employee_code: "",
      survey_id: "",
      survey_submitted: 0,
      survey_response: "",
      show_survey: true,
      show_msg: "",
      reject_remark: "",
      approval_status: "",
      jwtToken: "",
      username:"",
      approval_id:"",
    };
  },
  methods: {
    async Log_in() {
      try {
        this.loading = true;
        const username = this.$route.params.username;
        this.username = username;
        const details = { 
          username: username,
          type_id: 3
        };

        const response = await apis.uat_login(details);
        this.loading = false;

        if (response.data.status_code !== 200) {
          Toast.fire({ icon: "error", title: response.data.message });
          return;
        }

        const login_result = response.data;
        if (!login_result.survey_data) {
          Toast.fire({ icon: "warning", title: "record Not Found" });
          return;
        }

        // Populate survey info
        this.sgb_board_id = login_result.sgb_board_id;
        this.employee_code = login_result.user_code;
        this.jwtToken = login_result.jwtToken;
        this.survey_submitted = login_result.survey_submitted;
        this.survey_response = login_result.survey_response;
        this.survey_id = login_result.survey_data.survey_id;
        this.surveytemplate = JSON.parse(login_result.survey_data.survey_template);

        if (login_result.reject_remark) this.reject_remark = login_result.reject_remark;

        const user_survey_data = login_result.user_survey_data || {};

        // Survey visibility logic
        if (Object.keys(user_survey_data).length > 0) {
          this.approval_status = user_survey_data.approval_status;
          this.approval_id = user_survey_data.approval_id;
          if (this.approval_status === "Approved") {
            this.show_msg = "तुमचा शैक्षणिक तपशील मंजूर झाला आहे";
            this.show_survey = false;
          } else {
            this.show_survey = true;
          }          
        } else {
          this.show_survey = true;
        }

       
      } catch (err) {
        this.loading = false;
        console.error("Login/API error:", err);
        Toast.fire({ icon: "error", title: "Something went wrong" });
      }
    },
  },
  async mounted() {
    await this.Log_in();
    if (this.surveytemplate && this.surveytemplate!= {}) 
    {   
         // Apply SurveyJS theme
        this.survey = new Model(this.surveytemplate);
        if (this.survey_response) 
        {
          this.survey.data = JSON.parse(this.survey_response);
          if(this.survey.data.qualification_type_value && this.survey.data.qualification_type_value=='7225fc9e-3b43-42a0-91f9-25af6a685427')
          {
            this.survey.getQuestionByName("result").readOnly = true;
          } 
          
        }
        this.survey.applyTheme(themeJson);
        if (this.approval_id==212 || this.approval_id==214 || this.approval_id=='' || this.approval_id==null) 
        {
            this.survey.mode = "edit";
        }
        else
        {
          this.survey.mode = "display";
        }
        // When any dropdown (that loads from API) changes, store both text + value
        this.survey.onValueChanged.add((sender, options) => {
          const q = sender.getQuestionByName(options.name);

          // Apply only for dropdowns that use choicesByUrl
          if (q && q.choicesByUrl && q.selectedItem) {
            const selected = q.selectedItem;

            // Store both title and value in hidden fields
            sender.setValue(options.name + "_value", selected.value);
            sender.setValue(options.name + "_title", selected.text);
          }

          //logic for 8th for pass 
          if (options.name === "qualification_type") {
            if (options.value === "7225fc9e-3b43-42a0-91f9-25af6a685427") {
              sender.setValue("result", "Pass");
              // Disable dropdown
              sender.getQuestionByName("result").readOnly = true;
            } else {
              sender.clearValue("result");
              sender.getQuestionByName("result").readOnly = false;
            }
          }

          //
          if (options.name === "percentage" && options.value !== null) {
            sender.setValue("grade", null);
          }

          if (options.name === "grade" && options.value !== null) {
            sender.setValue("percentage", null);
          }

        });
        
        // ✅ Android 15–friendly file upload
        this.survey.onUploadFiles.add(async (survey, options) => {
          try {
            const file = options.files[0];

             const acceptedFileTypes  = ["application/pdf","image/jpeg", "image/png"];
             if (!acceptedFileTypes .includes(file.type)) {
               options.callback("error", "Only PDF or image(JPEG, PNG) file are accepted.");
               return;
             }

            const filepath = options.name + "_" + file.name;
            const userid = this.username + "_Education";
            const signedUrl = await lambda.getSignedURL(userid, filepath, file.type);

            const res = await fetch(signedUrl, {
              method: "PUT",
              headers: { "Content-Type": file.type },
              body: file,
            });

            if (!res.ok) throw new Error("Upload failed");
            
            options.callback("success", [
              {
                file : file,
                content: `https://s3.ap-south-1.amazonaws.com/sgbimages/${userid}/${filepath}`,
              },
            ]);
            

          } catch (err) {
            console.error(err);
            options.callback("error", err.message || "Upload failed");
          }
        });

        // Survey completion
        this.survey.onComplete.add(async (survey) => {
          this.loading = true;
          const surveyResult = JSON.stringify(survey.data);
          const details = {
            sgb_board_id: this.sgb_board_id,
            emp_code: this.employee_code,
            survey_id: this.survey_id,
            survey_response: surveyResult,
            type: "submit",
          };
          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.jwtToken}`,
          };

          const saveResp = await apis.save_guard_survey_new(details, { headers });
          this.loading = false;

          if (saveResp.data.status) {
            Toast.fire({ icon: "success", title: saveResp.data.message });
          } else {
            Toast.fire({ icon: "error", title: saveResp.data.message });
          }
        });

        this.survey.onPartialSend.add((survey) => {
              const result = JSON.stringify(survey.data);
              let jwtToken = this.jwtToken;
              let details = {
                "sgb_board_id": this.sgb_board_id,
                "emp_code": this.employee_code,
                "survey_id": this.survey_id,
                "survey_response": result,
                "type": 'save'
              }
              var header = {
                headers: {
                  "Content-Type": "application/json",
                  'Authorization': `Bearer ${jwtToken}`
                }
              };
              this.loading = true;
              var promise = apis.save_guard_survey_new(details, header);
              promise.then((response) => {
                this.loading = false;
              });
            });

        
        

        // Start the loader
        this.loading = true;

        // Stop it after 3 seconds (3000 ms)
        setTimeout(() => {
          this.loading = false;
        }, 3000);

    }
  },
};
</script>

<style>
.wrapper { display: flex; flex-direction: column; min-height: 91vh; }
.container { flex: 1; }
.card:last-child { margin-top: 5%; }
.error { color: red; }
</style>
